import Setting from '@assets/icons/setting.svg'
import { Icon } from './Icon'

export const SettingIcon = Icon(Setting)
